import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {Elevation} from '../../elevation'
import {DataTable as RmwcDataTable} from '@rmwc/data-table'
import '@rmwc/data-table/styles'

export const dataTableStyles = ({selector = '&&&'}) => css`
  ${selector} {
    border-width: 0;
    border-radius: 10px;
  }
`

const StyledRmwcDataTable = styled(RmwcDataTable)`
  ${dataTableStyles}
`

const DataTable = ({children, ...otherProps}) => (
  <Elevation z={1} wrap={true}>
    <StyledRmwcDataTable role="table" {...otherProps}>
      {children}
    </StyledRmwcDataTable>
  </Elevation>
)

DataTable.propTypes = {
  children: PropTypes.any,
  stickyColumns: PropTypes.number,
  stickyRows: PropTypes.number
}

export {DataTable}
